import {
	AllBanksLoanPurposes,
	Entitlements,
	PartnerConfigParameters,
	PartnerConfigResponse,
} from "@teylor-tools/Api";
import { Action, PartnerActions } from "../actions/partnerActions";

export interface PartnerState extends PartnerConfigParameters {
	configLoaded: boolean;
	terms_url: PartnerConfigResponse["terms_url"];
	data_protection_url: PartnerConfigResponse["data_protection_url"];
	userApplicationTypes: AllBanksLoanPurposes[];
	entitlements: Entitlements[];
}

const defaultState: PartnerState = {
	configLoaded: false,
	customer_support_email: "",
	customer_support_phone: "",
	display_name: "",
	terms_url: "",
	data_protection_url: "",
	userApplicationTypes: [],
	entitlements: [],
};

const partnerReducer = function (state = defaultState, action: Action): PartnerState {
	switch (action.type) {
		case PartnerActions.SET_PARTNER_PARAMETERS:
			return {
				...state,
				...action.parameters,
				configLoaded: true,
			};
	}

	return state;
};

export default partnerReducer;
